/* @sravni/react-header version 0.2.43 */
var css = "._iqahzu {\n  display: block;\n}\n._iqahzu svg {\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n";
var modules_3b87a8fb = {"container":"_iqahzu"};
import "../../../assets/components/InjectedIcon/index-4462f599.css";

export { css, modules_3b87a8fb as default };
